export default {
    btns: {
        close: '关闭',
        minimize: '最小化',
        maximize: '最大化',
        restore: '还原',
        prev: '上一张',
        next: '下一张',
        zoomIn: '放大',
        zoomOut: '缩小',
        rotate: '旋转',
        download: '下载',
        preview: '预览',
        saveAs: '另存为',
    },
    tips: {
        last: '上一页',
        next: '下一页',
        lastOne: '已是最后一张',
        firstOne: '已是第一张',
        lastPage: '已是最后一页',
        firstPage: '已是第一页',
        loading: '加载中',
        linkFailure: '链接已失效',
        recalled: '消息已被撤回',
        msgboxTitle: '提示',
        msgboxSubmitText: '确定',
    },
    components: {
        imageViewer: {
            title: '图片查看器',
        },
    },
};
